import React from 'react';
import Login from './auth/Login';
import Root from './Root';

const App = () => localStorage.jwtToken ? <Root /> : <Login />

export default App;
